import { dataPhoneEye } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhoneEye = /*#__PURE__*/createIcon(dataPhoneEye)
export default IconPhoneEye
